// Hex only: ids go into the filter URL param, whose separators are , ; | \
export const createTableFilterExpressionId = (): string =>
  crypto.randomUUID().slice(0, 8);
